"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfigurableStyle_1 = require("../../_utils/useConfigurableStyle");
var HeaderRight = function (_a) {
    var children = _a.children, className = _a.className, overrideDefaultClassName = _a.overrideDefaultClassName;
    var finalClassName = useConfigurableStyle_1.useConfigurableStyle({
        defaultClassName: "header__right",
        additionalClassName: className,
        overrideDefaultClassName: overrideDefaultClassName
    })[0];
    return (react_1.default.createElement("div", { className: finalClassName }, children));
};
exports.default = HeaderRight;
